import { Map as MapboxMap } from 'mapbox-gl'

// Mapbox projects into the map container's coordinate system; when the overlay's
// origin differs (padding, sibling chrome), shift by the origin delta.
export function projectToOverlay(
  map: MapboxMap,
  lng: number,
  lat: number,
  overlay: HTMLElement,
): { x: number; y: number } {
  const point = map.project([lng, lat])
  if (!overlay) {
    return { x: point.x, y: point.y }
  }
  const container = map.getContainer().getBoundingClientRect()
  const root = overlay.getBoundingClientRect()
  return {
    x: point.x + (container.left - root.left),
    y: point.y + (container.top - root.top),
  }
}
